













































import { defineComponent, PropType, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import BaseVideo from "@/components/BaseVideo";
import PlayButton from "@/components/PlayButton";
import { StreamUser } from "../../../types";

export default defineComponent({
  name: "UserStreamsView",
  components: {
    PlayButton,
    BaseButton,
    BaseIconButton,
    BaseSpinner,
    BaseVideo,
    BaseIcon,
  },
  props: {
    localStream: { type: MediaStream },
    streamers: { type: Array as PropType<StreamUser[]>, required: true },
    ownerId: { type: String },
    showInfo: { type: Boolean, default: false },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const showInfoId = ref<string | null>(null);
    const isSomeMuted = ref(false);
    const isSomePaused = ref(false);
    const player = ref<InstanceType<typeof BaseVideo>[]>([]);

    const showStream = (user: StreamUser) => user.constraints?.video;
    const getId = (user: StreamUser) => user.user?.id ?? "0";
    const onClick = (id: string) => {
      showInfoId.value = showInfoId.value === id ? "0" : id;
    };
    const getClass = (i: number) => {
      let result: Record<string, any> = {};
      if (props.streamers.length > 2) {
        result["__centered-mobile"] = props.streamers.length % 2 && i === props.streamers.length - 1;
      }
      if (props.streamers.length > 3) {
        result["__centered-desktop"] = props.streamers.length % 3 === 1 && i === props.streamers.length - 1;
        result["__1-2"] = (i + 1) % 3 === 1 && i === props.streamers.length - 2;
        result["__2-3"] = (i + 1) % 3 === 2 && i === props.streamers.length - 1;
      }
      return result;
    };

    const getScreenName = (user: UserPublicData) => {
      return user.id === authUser.value?.id ? $t("You") : user.screenName;
    };

    const getAutoplay = (user: StreamUser) => {
      return !!user.user && user.user.userId !== authUser.value?.id;
    };

    const play = () => {
      player.value.forEach(i => i.autoPlayRetryVideo());
      isSomeMuted.value = false;
    };

    return {
      showInfoId,
      authUser,
      isSomeMuted,
      isSomePaused,
      player,
      showStream,
      onClick,
      getId,
      getClass,
      getScreenName,
      getAutoplay,
      play,
    };
  },
});
